import script from "./ResetPasswordComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPasswordComponent.vue?vue&type=style&index=0&id=4b6d8ca1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6d8ca1"]])

export default __exports__